(() => {
  const mq = window.matchMedia('(max-width: 749px)');

  const initVideo = (v) => {
    // active l’anti-flash
    v.classList.add('is-pending');

    const show = () => {
      v.classList.remove('is-pending');
      v.classList.add('is-ready');
    };

    // si déjà prêt
    if (v.readyState >= 2) show();

    v.addEventListener('loadeddata', show, { once: true });
    v.addEventListener('playing', show, { once: true });

    // fallback: au pire on affiche au bout de 600ms
    setTimeout(show, 600);

    // tente play (silencieusement)
    const p = v.play();
    if (p && p.catch) p.catch(() => {});
  };

  const run = () => {
    if (!mq.matches) return;
    document.querySelectorAll('video.video-no-flash').forEach(initVideo);
  };

  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
})();
